import {
  MENSAJE_TIPO_AVISO_PROXIMO_A_VENCER,
  MENSAJE_TIPO_CARGA_MASIVA,
  MENSAJE_TIPO_DEVOLUCION,
  MENSAJE_TIPO_CANCELACION,
  MENSAJE_TIPO_INICIO_CANCELACION,
  MENSAJE_TIPO_EXITO_DEVOLUCION,
  MENSAJE_TIPO_CANCELACION_DEVOLUCION
} from '../../constants/mensajesTipos.js'

/**
 * Devuelve la referencia mostrable de una notificación (etiqueta + id de la entidad
 * asociada), o null si el tipo no tiene una referencia navegable.
 * @param {Object} notificacion
 * @returns {{ etiqueta: string, id: number } | null}
 */
export const obtenerReferencia = (notificacion) => {
  const mensajesCancelacion = [
    MENSAJE_TIPO_DEVOLUCION,
    MENSAJE_TIPO_CANCELACION,
    MENSAJE_TIPO_INICIO_CANCELACION,
    MENSAJE_TIPO_EXITO_DEVOLUCION,
    MENSAJE_TIPO_CANCELACION_DEVOLUCION
  ]
  if (mensajesCancelacion.includes(notificacion.idMensajeTipo)) {
    return notificacion.idPedido > 0 ? { etiqueta: 'del pedido', id: notificacion.idPedido } : null
  }

  switch (notificacion.tipoNotificacion) {
    case 'PUBLICACION':
      return notificacion.idPublicacion > 0
        ? { etiqueta: 'en la publicación', id: notificacion.idPublicacion }
        : null
    case 'PRESUPUESTO':
      return notificacion.idPresupuesto > 0
        ? { etiqueta: 'en el presupuesto', id: notificacion.idPresupuesto }
        : null
    case 'PEDIDO_CABECERA':
      return notificacion.idPedido > 0
        ? { etiqueta: 'en el pedido', id: notificacion.idPedido }
        : null
    case 'COMPRAS':
      return notificacion.idPedido > 0
        ? { etiqueta: 'en el pedido', id: notificacion.idPedido }
        : null
    case 'VENTAS':
      return notificacion.idPedido > 0
        ? { etiqueta: 'en el pedido', id: notificacion.idPedido }
        : null
    default:
      return null
  }
}

/**
 * Construye el destino de navegación (string o { pathname, state }) de una notificación.
 * @param {Object} notificacion - Notificación con sus ids (tipoNotificacion, idPublicacion, etc.).
 * @param {number} idUsuario - Id del usuario actual, usado para resolver vendedor/comprador.
 * @returns {string | { pathname: string, state: Object }}
 */
export const obtenerURL = (notificacion, idUsuario) => {
  const {
    tipoNotificacion,
    idPresupuesto,
    idPublicacion,
    idPedidoItem,
    idVendedor,
    idPedido,
    idComprador,
    idMensajeTipo,
    idJobCargaMasiva
  } = notificacion

  if (idMensajeTipo === MENSAJE_TIPO_CARGA_MASIVA) {
    return idJobCargaMasiva
      ? `/Publicaciones/CargaMasiva/${idJobCargaMasiva}`
      : '/Publicaciones/Administrar'
  }

  if (idMensajeTipo === MENSAJE_TIPO_DEVOLUCION || idMensajeTipo === MENSAJE_TIPO_CANCELACION) {
    return idPedido > 0 ? `/Pedido/${idPedido}` : null
  }

  if (idMensajeTipo === MENSAJE_TIPO_AVISO_PROXIMO_A_VENCER) {
    return idPublicacion > 0
      ? `/Publicaciones/Administrar/${idPublicacion}`
      : '/Publicaciones/Administrar'
  }

  switch (tipoNotificacion) {
    case 'PRESUPUESTO':
      return idPresupuesto > 0 ? `/Presupuesto/${idPresupuesto}` : null
    case 'PUBLICACION':
      return idPublicacion > 0
        ? {
            pathname: `/${idVendedor === idUsuario ? 'PreguntasVendedor' : 'PreguntasComprador'}`,
            state: {
              idPublicacion,
              idVendedor,
              idComprador: idVendedor === idUsuario ? idComprador : null
            }
          }
        : null
    case 'COMPRAS':
      return idPedidoItem > 0 ? `/PedidoItem/${idPedidoItem}` : null
    case 'PEDIDO_CABECERA':
      return idPedido > 0
        ? {
            pathname: `/Pedido/${idPedido}`,
            state: { esVentas: idVendedor === idUsuario }
          }
        : null
    case 'PUBLICACION_VENCIDA':
      return `/Publicaciones/Administrar`
    case 'TIENDA_OFICIAL':
      return `/ConvertirTiendaOficial`
    case 'LISTA_ENVIO':
      return `/ListasEnvio`
    default:
      return idPedidoItem > 0 ? `/PedidoItem/${idPedidoItem}` : null
  }
}
